module.exports = __webpack_public_path__ + "static/media/CloseChatSolid.4cddef8b.png";